import { Component, computed, inject } from "@angular/core"
import { MapService } from "../../../map/map.service"
import { UiDialogComponent } from "ui-dialog"
import { UiInheritDirective } from "ui-inherit"
import { environment } from "../../../../../environments/environment"
import { StorageService } from "../../../../services/storage.service"

@Component({
  imports: [
    UiInheritDirective,
    UiDialogComponent,
  ],
  standalone: true,
  template: `
    @if (showFhaManual()) {
      <lib-ui-dialog
        [maxWidth]="1100"
        (cancelAndClose)="closeModal()"
      >
        <div ngProjectAs="title">
          FHA Manual
        </div>

        <div ngProjectAs="content">
          <div class="row">
            <div
              [style.min-width.px]="450"
              class="flex-1"
            >
              <video
                #videoElement
                [muted]="true"
                autoplay loop playsinline
              >
                <source 
                  [src]="underwritingManualVideo()"
                  type="video/mp4"
                >
              </video>
            </div>
            <div 
              [style.min-width.px]="350"
              class="column flex-1 p-4"
            >
              <div>
                Although HOLC redlining maps are the most visible example of redlining, the most impactful redlining was
                likely done by the Federal Housing Administration. The huge investment of FHA-backed home loans went
                predominantly to whiter, wealthier suburbs: leaving diverse cities in decline and disinvestment. In this
                passage from the 1938 Federal Housing Administration's Underwriting Manual, the explicitly racist
                guidance of the U.S. government is plainly visible.
              </div>
              <div>
                These kinds of discriminatory practices are also enshrined in the 1923 National Association of Real
                Estate Brokers textbook, which states “The colored people certainly have a right to life, liberty and
                the pursuit of happiness but they must recognize the economic disturbance which their presence in a
                white neighborhood causes and forego their desire to split off from the established district where the
                rest of their race lives.”
              </div>
            </div>
          </div>
        </div>
      </lib-ui-dialog>
    }
  `,
  selector: "e2e-underwriting-manual-dialog",
})
export class UnderwritingManualDialogComponent {
  private localMapsService = inject(MapService)
  private storageService = inject(StorageService)

  showFhaManual = this.localMapsService.underwritingManual

  underwritingManualVideo = computed(() =>
    // environment.imagekit_urlEndpoint + "/assets/images/UDTR-FHA-Manual.mp4"
   this.storageService.getFileUrl("/assets/images/UDTR-FHA-Manual.mp4")
  )

  underwritingImage = "/assets/images/underwriting-image.png"
  // screenshot3 = "/assets/pages/local-maps/ScreenShot3.png"
  // screenshot4 = "/assets/pages/local-maps/ScreenShot4.png"
  // screenshot5 = "/assets/pages/local-maps/ScreenShot5.png"

  closeModal() {
    this.localMapsService.closeModal()
  }

}
